import {
  Box,
  HStack,
  IconButton,
  Progress, Slider, SliderFilledTrack, SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";
import React, {MutableRefObject, useRef, useState} from "react";
import {IoPause,IoPlay,IoVolumeMedium} from "react-icons/io5";

import {useTheme} from "../hooks/ThemeProvider";
import Markdown from "./Markdown";

const formatTime = (time: number) => {
  // const hours = Math.floor(time / 3600);
  const remainder = time % 3600;
  const minutes = Math.floor(remainder / 60);
  const seconds = Math.floor(remainder % 60);

  const mm = minutes.toString().padStart(2, '0');
  const ss = seconds.toString().padStart(2, '0');

  return `${mm}:${ss}`;
}

type AudioProps = {
  sourceUrl : string;
  timesPlayed?: MutableRefObject<number>;
  onAudioPlayed?: (timesPlayed: number) => void;
  maxNumberOfReproductions?: number;
};

const AudioPlayer = ( props: AudioProps ) => {
  const theme = useTheme().theme;
  const maxNumberOfReproductions = props.maxNumberOfReproductions!==undefined?props.maxNumberOfReproductions:2;
  const infinitePlays = maxNumberOfReproductions===0;
  const [playable, setPlayable] = useState<boolean>(
    (infinitePlays || (props.timesPlayed !== undefined && props.timesPlayed.current < maxNumberOfReproductions))
  );
  const [progressValue, setProgressValue] = useState<number>(0);
  const [formattedTime, setFormattedTime] = useState<string>("00:00");

  const audioPlayer = useRef<HTMLAudioElement>(null);

  const playIcon = <IoPlay />;
  const pauseIcon = <IoPause />;
  const [audioIcon, setAudioIcon] = useState<JSX.Element>(playIcon);

  const playIf = async () => {
    if (props.timesPlayed && playable) {
      if (infinitePlays || (props.timesPlayed.current < maxNumberOfReproductions)) {
        props.timesPlayed.current = props.timesPlayed.current + 1;
        setPlayable(false);
        // save timesPlayed to the DB
        if (props.onAudioPlayed) props.onAudioPlayed(props.timesPlayed.current);
        await audioPlayer?.current?.play().catch(() => { });
      }
    } else
      if (audioPlayer?.current && !audioPlayer?.current?.paused) {
        setAudioIcon(playIcon);
        audioPlayer?.current?.pause();
      }
      else {
        setAudioIcon(pauseIcon);
        audioPlayer?.current?.play().catch(() => { });
      }
  };

  const updateProgress = () =>{
    if (audioPlayer && audioPlayer.current) {
      setProgressValue(audioPlayer?.current?.currentTime / audioPlayer?.current?.duration * 100);
      setFormattedTime(formatTime(audioPlayer?.current?.currentTime || 0));
    }
  }

  const changeVolume = (volume:number) =>{
    if (audioPlayer && audioPlayer.current) {
      audioPlayer.current.volume = (volume) / 100;
    }
  }

  /*
  useEffect(() => {
    console.log(!playable || audioPlayer?.current?.paused===undefined
      || audioPlayer?.current?.paused);
    if (!playable || audioPlayer?.current?.paused===undefined
      || audioPlayer?.current?.paused)
      setAudioIcon(playIcon);
    else
      setAudioIcon(pauseIcon);
  }, [playable, audioPlayer?.current?.paused])
  */

  const refresh = ()=>{
    if (!props.timesPlayed)
      setPlayable(true);
    setProgressValue(0);
    setFormattedTime("00:00");
    if (audioPlayer && audioPlayer.current) {
      audioPlayer.current.currentTime = 0;
    }
  }
  return (
    <Box>
      <HStack
        marginTop="2"
        marginBottom="2"
        padding="2"
        borderWidth="1px"
        borderRadius="lg"
        borderColor={theme.OUTLINE}
        borderStyle="solid"
        align="center"
        spacing='10px'
      >
        {/*
        the default audio controls are hidden
        custom controls are placed to have better control on the configuration
         for example to prevent seeking the audio
        */}
        <audio ref={audioPlayer}
               controls={false}
               onTimeUpdate={()=> {updateProgress()}}
               onEnded={()=> setPlayable(infinitePlays || !props.timesPlayed ||
                 (props.timesPlayed && props.timesPlayed.current < maxNumberOfReproductions))}
               onLoadedData={()=>refresh()}
        >
          <source type="audio/mpeg"
                  src={props.sourceUrl}
          />

        </audio>
        <IconButton
          aria-label="Reproducir Audio"
          onClick={()=>  { return playIf(); }}
          disabled={!playable}
          /*icon={ !playable || audioPlayer?.current?.paused===undefined
            || audioPlayer?.current?.paused ?
            playIcon : pauseIcon }*/
          icon={ audioIcon }
          size="lg"
          colorScheme={theme.COLOR_SCHEME}
        />
        <Progress  max={100}
                    backgroundColor={theme.LIGHT_BG}
                   colorScheme={theme.COLOR_SCHEME}
                   value={progressValue} size="sm" width={100}/>
        <Markdown
          content={formattedTime}
        />
        <IoVolumeMedium />
        <Slider aria-label='slider-ex-1'
                size="sm"
                defaultValue={100}
                onChange={(val) => changeVolume(val)}
                width={100}
                colorScheme={theme.COLOR_SCHEME}>
          <SliderTrack>
            <SliderFilledTrack />
          </SliderTrack>
          <SliderThumb boxSize={3} bg={theme.TEXT_PRIMARY} />
        </Slider>
      </HStack>
    </Box>
  );
};

export default AudioPlayer;
